/**
 * @file Section.tsx
 * @summary Composant global
 *
 * Composant transverse utilisé dans plusieurs pages (header, footer, SEO, layout…).
 *
 * @see docs/07-CODEBASE.md — conventions de code
 * @see docs/02-FRONTEND.md — design system (tokens HSL, typographie)
 */
import { ReactNode } from "react";
import { useInView } from "@/hooks/use-in-view";
import { cn } from "@/lib/utils";

interface SectionProps {
  id?: string;
  children: ReactNode;
  className?: string;
  dark?: boolean;
}

export default function Section({ id, children, className, dark }: SectionProps) {
  const { ref, isInView } = useInView(0.1);
  return (
    <section
      id={id}
      ref={ref}
      className={cn(
        "py-20 md:py-28 transition-all duration-700",
        dark ? "bg-charcoal text-charcoal-foreground" : "",
        isInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8",
        className
      )}
    >
      <div className="container max-w-[1200px] mx-auto px-4 md:px-8">{children}</div>
    </section>
  );
}
